export default "__VITE_ASSET__Q1qGv2VY__"